@if (planResolved) {
  <app-drawer
    [(opened)]="drawerOpened"
    [pages]="pages"
    [activePageNumber]="showingProjectView || showingFileView ? null : (activePlanPage?.getPageNumber() ?? null)"
    [activeFileId]="showingProjectView ? null : activeFileId"
    [projectSelected]="showingProjectView"
    [fileLabelActivatesFile]="fileNodeSelectionEnabled"
    [planId]="(planId$ | async) ?? ''"
    [projectName]="projectName"
    [loading]="(planLoading$ | async) ?? false"
    [checkedPagesByFile]="checkedPagesByFile"
    [powerUserMode]="powerUserMode"
    [activeRegionSlug]="showingProjectView || showingFileView ? null : activeRegionPath"
    [filePageStatuses]="filePageStatuses"
    [showComplianceWarnings]="(tableOfContentsWarnings$ | async) ?? true"
    (fileActivated)="onFileActivated($event)"
    (pageActivated)="onPageActivated($event)"
    (regionActivated)="onRegionActivated($event)"
    (regionRestored)="onRegionRestored($event)"
    (regionHovered)="onRegionHovered($event)"
    (checkedPagesChanged)="onCheckedPagesChanged($event)"
  >
    <div class="main-viewport">
      @for (key of renderKeys; track key) {
        <div class="main-content" [@pageSlide]="{ value: renderKey, params: slideParams }">
          @if (showingProjectView && !hasError) {
            <div class="project-settings-view">
              <app-project-settings></app-project-settings>
            </div>
          }

          @if (showingFileView && activeFileId && !hasError) {
            <app-file-view
              [projectId]="(planId$ | async) ?? ''"
              [fileId]="activeFileId"
              [selectedTab]="fileViewTab"
              (pageStatusesChange)="onFilePageStatusesChange($event)"
            ></app-file-view>
          }

          @if (!showingProjectView && !showingFileView && !hasError) {
            <mat-tab-group
              [mat-stretch-tabs]="false"
              [preserveContent]="true"
              [selectedIndex]="(activeTabIndex$ | async)!"
              (selectedTabChange)="onTabChange($event)"
            >
              @for (tab of tabs$ | async; track tab; let i = $index) {
                <mat-tab [label]="tab.label">
                  <ng-template mat-tab-label>
                    @if (isClosableTab(tab)) {
                      <span class="tab-title" [attr.title]="tab.label">{{ tab.label }}</span>
                      <button
                        mat-icon-button
                        type="button"
                        class="tab-close-button"
                        [attr.aria-label]="'Close ' + tab.label"
                        [matTooltip]="'Close ' + tab.label"
                        (click)="closeTab(i, $event)"
                        (keydown.enter)="$event.stopPropagation()"
                        (keydown.space)="$event.stopPropagation()"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    } @else {
                      {{ tab.label }}
                    }
                  </ng-template>
                  <ng-template matTabContent>
                    <ng-container [ngComponentOutlet]="tab.component"></ng-container>
                  </ng-template>
                </mat-tab>
              }
            </mat-tab-group>
          }
        </div>
      }
    </div>
  </app-drawer>
} @else {
  <div class="content-skeleton">
    <div class="skeleton-sidebar">
      <div class="skeleton-bar skeleton-bar-short"></div>
      <div class="skeleton-bar"></div>
      <div class="skeleton-bar"></div>
      <div class="skeleton-bar skeleton-bar-medium"></div>
      <div class="skeleton-bar"></div>
      <div class="skeleton-bar skeleton-bar-short"></div>
    </div>
    <div class="skeleton-main">
      <div class="skeleton-bar skeleton-bar-heading"></div>
      <div class="skeleton-bar"></div>
      <div class="skeleton-bar skeleton-bar-medium"></div>
      <div class="skeleton-bar"></div>
      <div class="skeleton-bar skeleton-bar-short"></div>
    </div>
  </div>
}
